/**
 * Supabase constants
 */

// Supabase URL
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
